export enum EnumHora {
  Hora1 = 1,
  Hora2 = 2,
  Hora3 = 3,
  Hora4 = 4,
  Hora5 = 5,
  Hora6 = 6,
  Hora7 = 7,
  Hora8 = 8,
  Hora9 = 9,
  Hora10 = 10,
  Hora11 = 11,
  Hora12 = 12,
  Hora13 = 13,
  Hora14 = 14,
  Hora15 = 15,
  Hora16 = 16,
  Hora17 = 17,
  Hora18 = 18,
  Hora19 = 19,
  Hora20 = 20,
  Hora21 = 21,
  Hora22 = 22,
  Hora23 = 23,
  Hora24 = 24,
  Hora3V = 25,
  Hora3I = 26
}

export enum EnumQHora {
  Hora1_1 = 11,
  Hora1_2 = 12,
  Hora1_3 = 13,
  Hora1_4 = 14,
  Hora2_1 = 21,
  Hora2_2 = 22,
  Hora2_3 = 23,
  Hora2_4 = 24,
  Hora3_1 = 31,
  Hora3_2 = 32,
  Hora3_3 = 33,
  Hora3_4 = 34,
  Hora4_1 = 41,
  Hora4_2 = 42,
  Hora4_3 = 43,
  Hora4_4 = 44,
  Hora5_1 = 51,
  Hora5_2 = 52,
  Hora5_3 = 53,
  Hora5_4 = 54,
  Hora6_1 = 61,
  Hora6_2 = 62,
  Hora6_3 = 63,
  Hora6_4 = 64,
  Hora7_1 = 71,
  Hora7_2 = 72,
  Hora7_3 = 73,
  Hora7_4 = 74,
  Hora8_1 = 81,
  Hora8_2 = 82,
  Hora8_3 = 83,
  Hora8_4 = 84,
  Hora9_1 = 91,
  Hora9_2 = 92,
  Hora9_3 = 93,
  Hora9_4 = 94,
  Hora10_1 = 101,
  Hora10_2 = 102,
  Hora10_3 = 103,
  Hora10_4 = 104,
  Hora11_1 = 111,
  Hora11_2 = 112,
  Hora11_3 = 113,
  Hora11_4 = 114,
  Hora12_1 = 121,
  Hora12_2 = 122,
  Hora12_3 = 123,
  Hora12_4 = 124,
  Hora13_1 = 131,
  Hora13_2 = 132,
  Hora13_3 = 133,
  Hora13_4 = 134,
  Hora14_1 = 141,
  Hora14_2 = 142,
  Hora14_3 = 143,
  Hora14_4 = 144,
  Hora15_1 = 151,
  Hora15_2 = 152,
  Hora15_3 = 153,
  Hora15_4 = 154,
  Hora16_1 = 161,
  Hora16_2 = 162,
  Hora16_3 = 163,
  Hora16_4 = 164,
  Hora17_1 = 171,
  Hora17_2 = 172,
  Hora17_3 = 173,
  Hora17_4 = 174,
  Hora18_1 = 181,
  Hora18_2 = 182,
  Hora18_3 = 183,
  Hora18_4 = 184,
  Hora19_1 = 191,
  Hora19_2 = 192,
  Hora19_3 = 193,
  Hora19_4 = 194,
  Hora20_1 = 201,
  Hora20_2 = 202,
  Hora20_3 = 203,
  Hora20_4 = 204,
  Hora21_1 = 211,
  Hora21_2 = 212,
  Hora21_3 = 213,
  Hora21_4 = 214,
  Hora22_1 = 221,
  Hora22_2 = 222,
  Hora22_3 = 223,
  Hora22_4 = 224,
  Hora23_1 = 231,
  Hora23_2 = 232,
  Hora23_3 = 233,
  Hora23_4 = 234,
  Hora24_1 = 241,
  Hora24_2 = 242,
  Hora24_3 = 243,
  Hora24_4 = 244,
  Hora3V_1 = 251,
  Hora3V_2 = 252,
  Hora3V_3 = 253,
  Hora3V_4 = 254,
  Hora3I_1 = 261,
  Hora3I_2 = 262,
  Hora3I_3 = 263,
  Hora3I_4 = 264
}
